export default __webpack_public_path__ + "176a65f44a88183cf1dc65f1a443b4f6.ttf";